export default typeof document !== 'undefined' && window.performance
	? () => performance.now()
	: () => Date.now();



// WEBPACK FOOTER //
// ./lib/pagehandler/utils/hrtime.js